import React, { useEffect } from "react";
import HeaderContainer from "./Header";
import { useNavigate } from "react-router-dom";
import { Card, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import { Button } from "../components/ui/button";
import { getToken } from "../helpers/tokenManager";

const SignupConfirmed: React.FC<any> = () => {
  const navigate = useNavigate();
  const signedIn = !!getToken();

  useEffect(() => {
    if (signedIn) navigate("/dashboard", { replace: true });
  }, [signedIn, navigate]);

  return (
    <Flex
      minHeight="100vh"
      width="100%"
      maxWidth="1392px"
      margin="0 auto"
      paddingTop="24px"
      paddingBottom="24px"
      direction="column"
      gap="24px"
    >
      {/* Header */}
      <HeaderContainer behavior="signin" />

      {/* Main container to center the content */}
      <Flex flex={1} justifyContent="center" alignItems="center" padding="20px">
        {/* Content wrapper for max width */}
        <Stack maxWidth="480px" width="100%" alignItems="center" gap={8}>
          {/* Page title */}
          <Heading
            as="h1"
            textAlign="center"
            color="#18181b"
            fontSize="24px"
            fontWeight="bold"
            letterSpacing="-0.4px"
            lineHeight="32px"
          >
            Success!
          </Heading>

          {/* Email Confirmed Card */}
          <Card.Root width="100%">
            <Card.Body>
              <Stack gap={4} alignItems="center" textAlign="center">
                <Text fontSize="md" color="#52525b" lineHeight="24px">
                  Your email address has been confirmed successfully. Sign in to access your dashboard.
                </Text>

                <Button
                  onClick={() => navigate("/signin")}
                  variant="solid"
                  colorPalette="purple"
                  bg="#9333ea"
                >
                  Sign in
                </Button>
              </Stack>
            </Card.Body>
          </Card.Root>
        </Stack>
      </Flex>
    </Flex>
  );
};

export default SignupConfirmed;
